<div class="w-full rounded-xl border border-gray-100 bg-white shadow-sm">
  <h4 class="border-b border-gray-100 px-5 py-4 font-lato text-sm font-bold uppercase tracking-wide text-blue-950">
    {{ title }}
  </h4>
  <div class="grid grid-cols-2 divide-x divide-y divide-gray-100">
    @for (i of data; track $index) {
      <div class="bg-white px-5 py-4">
        <span class="flex items-center gap-1 font-lato text-xs font-semibold uppercase tracking-wide text-brand-muted">
          @if (i.icon) {
            <mat-icon [inline]="true">{{ i.icon }}</mat-icon>
          }
          {{ i.title }}
        </span>
        @if (i.type !== 'date') {
          <p class="mt-1 font-lato text-sm font-medium text-blue-950">{{ i.value || '—' }}</p>
        } @else {
          <p class="mt-1 font-lato text-sm font-medium text-blue-950">{{ i.value | date: 'MM/dd/yyyy' }}</p>
        }
      </div>
    }
  </div>
</div>
